import React from 'react';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { QuickBooksTile } from './components/QuickBooksTile.component';
import { SalesforceTile } from './components/SalesforceTile.component';
import { KekaTile } from './components/KekaTile.component';
import { JiraTile } from './components/JiraTile.component';
import { SageHRTile } from './components/SageHRTile.component';
import { ZohoPeopleTile } from './components/ZohoPeopleTile.component';
import styles from './IntegrationsPage.module.scss';

export const IntegrationsPageComponent = () => {
  return (
    <div className={styles.integrationsPage}>
      <Text
        variant={textVariantsEnum.Header}
        fontWeight={fontWeightEnum.Semibold}
      >
        Integrations
      </Text>
      <p className={`mt-2 mb-0 ${styles.subtitle}`}>
        Connect third-party services to sync your workforce data.
      </p>
      <div className={styles.tileList}>
        <QuickBooksTile />
        <SalesforceTile />
        <KekaTile />
        <JiraTile />
        <SageHRTile />
        <ZohoPeopleTile />
      </div>
    </div>
  );
};
